export const mapInterestToStackedBar = (
    data
        : {
            baseAmounts: number[]
            gainedAmounts: number[]
        }) => {
    const series = [
        {
            color: '#DDD',
            data: data.baseAmounts?.map((b: number, index: number) => ({ x: index, y: b }))
        },
        {
            color: '#F00',
            data: data.gainedAmounts?.map((b: number, index: number) => ({ x: index, y: b }))
        },
    ]

    return series;
}